import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, dmpRemoteCommandFailureContextualizedType, dmpRemoteCommandSuccessContextualizedType } from "dmpconnectjsapp-base/actions";
import { put, take }                                                                                                                                                      from 'redux-saga/effects';

export function * sendActionAndWaitResult (action) {
  const { func, section, subSection } = action;
  
  yield put(func);
  
  let result;
  while (!result) {
    const actionResult = yield take(
      [
        dmpCommandSuccessContextualizedType(section),
        dmpCommandFailureContextualizedType(section),
        dmpRemoteCommandSuccessContextualizedType(section),
        dmpRemoteCommandFailureContextualizedType(section),
      ],
    );
    
    const { context: { subSection: actionSubSection } } = actionResult;
    if (subSection === actionSubSection) {
      result = actionResult;
    }
  }
  return result;
}